export default {
  name: 'MaterialSymbolsLightSettingsRounded'
};